import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SidebarToggleDirective } from './share/sidebar.directive';
import { DropdownDirective } from './share/dropdown.directiv';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { SigninComponent } from './auth/signin/signin.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppSettings } from '../settings';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth-guard.service';
import { AuthInterceptor } from './auth/auth-interceptor.service';
import { AppStorageService } from './share/appstorage.service';
import { AppRoutingModule } from './app.routing';
import { LayoutsComponent } from './layouts/layouts.component';
import { HeaderComponent } from './header/header.component';
import { ChangesService } from './share/changes.service';
import { NgxResponsiveStackTableModule } from 'ngx-responsive-stack-table';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ngx-currency-mask/src/currency-mask.config';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomTranslationLoader } from './share/custom.translation.loader';
import { ModalModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap';
import { AdminStateComponent } from './admin-state/state.component';
import { PartialReportComponent } from './partial-report/partial-report.component';
import { NgPipesModule } from 'ngx-pipes';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipe } from './pipes/filterPipe';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { UnpaidComponent } from './unpaid/unpaid.component';

// locale
import { LOCALE_ID } from '@angular/core';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RoleGuardService } from './auth/role-guard.service';
import { CostcenterTransactionItemComponent } from './admin-state/costcenter-transaction-item/costcenter-transaction-item.component';
import { PartialReportItemsComponent } from './partial-report/partial-report-items/partial-report-items.component';
import { TerminalActionsSsbtReportComponent } from './terminal-actions-ssbt-report/terminal-actions-ssbt-report.component';
import { TerminalActionsSsbtReportPartialComponent } from './terminal-actions-ssbt-report/terminal-actions-ssbt-report-partial/terminal-actions-ssbt-report-partial.component';
import { TerminalConnectivityStatusReportComponent } from './terminal-connectivity-status-report/terminal-connectivity-status-report.component';
import { TerminalConnectivityStatusReportPartialComponent } from './terminal-connectivity-status-report/terminal-connectivity-status-report-partial/terminal-connectivity-status-report-partial.component';
import { AverageTrafficItemComponent } from './average-traffic/average-traffic-item/average-traffic-item.component';
import { AverageTrafficComponent } from './average-traffic/average-traffic.component';
import { TerminalOverviewReportComponent } from './terminal-overview-report/terminal-overview-report.component';
import { TerminalOverviewReportPartialComponent } from './terminal-overview-report/terminal-overview-report-partial/terminal-overview-report-partial.component';
import { UnpaidItemComponent } from './unpaid/unpaid-item/unpaid-item.component';


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  allowZero: false,
  decimal: '.',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: ','
};

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    LayoutsComponent,
    SidebarToggleDirective,
    DropdownDirective,
    HeaderComponent,
    AdminStateComponent,
    PartialReportComponent,
    ChangePasswordComponent,
    CostcenterTransactionItemComponent,
    PartialReportItemsComponent,
    FilterPipe,
    TerminalActionsSsbtReportComponent,
    TerminalActionsSsbtReportPartialComponent,
    TerminalConnectivityStatusReportComponent,
    TerminalConnectivityStatusReportPartialComponent,
    AverageTrafficItemComponent,
    AverageTrafficComponent,
    TerminalOverviewReportComponent,
    TerminalOverviewReportPartialComponent,
    UnpaidComponent,
    UnpaidItemComponent
],
  imports: [
    BrowserModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxResponsiveStackTableModule,
    NgxPaginationModule,
    AppRoutingModule,
    NgxSpinnerModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CurrencyMaskModule,
    NgSelectModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgPipesModule
  ],
  providers: [
    AppSettings, AuthService, AuthGuard, RoleGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: LOCALE_ID, deps: [AppSettings], useFactory: (appSettings) => appSettings.getLocale() },
    AppStorageService,
    ChangesService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslationLoader(http);
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/app.module.ts